import { EDealType } from '../../types/dealType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IEstimationRentData, IEstimationSaleData } from '../../types/redux/estimation';

export enum EActionTypes {
  Request = 'estimation/request',
  Success = 'estimation/success',
  Failure = 'estimation/failure',
  Reset = 'estimation/reset_error',
}

export interface IBasePayload {
  dealType: EDealType;
}

export interface IGetEstimationSuccessPayload extends IBasePayload {
  data: IEstimationSaleData | IEstimationRentData | null;
  filtersHash: string;
}

export const getEstimationRequest = actionGenerator<EActionTypes.Request, IBasePayload>(EActionTypes.Request);
export const getEstimationSuccess = actionGenerator<EActionTypes.Success, IGetEstimationSuccessPayload>(
  EActionTypes.Success,
);
export const getEstimationFailure = actionGenerator<EActionTypes.Failure, IBasePayload>(EActionTypes.Failure);
export const _resetEstimationError = actionGenerator<EActionTypes.Reset, IBasePayload>(EActionTypes.Reset);

export type TGetEstimationRequest = ReturnType<typeof getEstimationRequest>;
export type TGetEstimationSuccess = ReturnType<typeof getEstimationSuccess>;
export type TGetEstimationFailure = ReturnType<typeof getEstimationFailure>;
export type TResetEstimationError = ReturnType<typeof _resetEstimationError>;

export type TGetEstimationActions =
  | TGetEstimationRequest
  | TGetEstimationSuccess
  | TGetEstimationFailure
  | TResetEstimationError;
